<div>
  <h4 class="db-cdn-clear-cache__title">Entirely clear Cloudflare cache</h4>
  <p class="db-cdn-clear-cache__desc">Clear both static and HTML cache. A page will be cached again on first visit.</p>
</div>
<button class="ds-btn-outline-green" (click)="openClearCacheDialog()" [ngClass]="{'ds-btn-disabled': loading}">
  <span *ngIf="!loading">Clear</span>
  <span class="ds-spinner-circle" *ngIf="loading"></span>
</button>
